import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { getMethod } from "../../../../function/helper";
import { useEffect, useRef, useState } from "react";
import style from "./SearchCity.module.css";

function SearchCity({ onChoose }) {
  const [cityQuery, setCityQuery] = useState("");
  const [uniq] = useState(Math.random());
  const abortControllerRef = useRef(new AbortController());

  const { data: cities, refetch } = useQuery({
    queryKey: ["quickPriceSearchCity", uniq],
    queryFn: () =>
      getMethod(
        "/address/v1/city/search?cityQuery=" + cityQuery,
        {},
        abortControllerRef.current.signal
      ).then(res => {
        if (res && res.status === 200) {
          return res.result.map(item => ({
            value: item.id,
            label: item.name,
          }));
        }

        return [];
      }),

    enabled: false,
    initialData: [{ value: 0, label: "..." }],
  });

  useEffect(() => {
    if (cityQuery.length >= 2) {
      refetch();

      return () => {
        abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
      };
    }
  }, [cityQuery]);

  return (
    <Select
      className={style.box}
      options={cities}
      onChange={e => onChoose(e.value)}
      isSearchable={true}
      onInputChange={string => setCityQuery(string)}
      placeholder="&nbsp;نام شهر را جستجو کنید..."
    />
  );
}

export default SearchCity;
